import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import {FormattedMessage} from 'react-intl';
import messages from '../page/messages/general/messages';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{
                    width: '100%',
                    minHeight: '55vh',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    p: 3,
                }}>
                    <h2><FormattedMessage id={messages.error_boundary_title} /></h2>
                    <p><FormattedMessage id={messages.error_boundary_message} /></p>
                    <Button variant="contained" color="primary" onClick={() => window.location.reload()}>
                        <FormattedMessage id={messages.error_boundary_reload} />
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
